import { useMutation, useQueryClient } from "@tanstack/react-query"
import { insertBcInfo, updateDealCurrentStep } from "@/api"
import { DealStep } from "@/types"

export const useInsertBc = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      dealId,
      legalName,
      email,
      address,
      city,
      state,
      zip,
      country,
      phone,
      dealManagerName,
      dealManagerEmail,
      birthDate,
      ssn,
      isMarried,
      isUsCitizen,
      spouseName,
      spouseEmail,
    }: {
      dealId: number
      legalName: string
      email: string
      address: string
      city: string
      state: string
      zip: string
      country?: string
      phone: string
      dealManagerName: string
      dealManagerEmail: string
      birthDate: string
      ssn: string
      isMarried: string
      isUsCitizen: string
      spouseName: string
      spouseEmail: string
    }) =>
      insertBcInfo({
        dealId,
        legalName,
        email,
        address,
        city,
        state,
        zip,
        country,
        phone,
        dealManagerName,
        dealManagerEmail,
        birthDate,
        ssn,
        isMarried,
        isUsCitizen,
        spouseName,
        spouseEmail
      }),
    onSuccess: (_data, variables) => {
      updateDealCurrentStep(variables.dealId, DealStep.SIGN_BC)
        .then(() => queryClient.invalidateQueries({ queryKey: ["clientDeals"] }))
    },
  })
}